export enum FILE_EVENT_TYPE_ENUM{
    change = 'change',
    drop = 'drop'
}

export enum FILE_TYPE{
    XLSX = 'xlsx',
    XLSM = 'xlsm',
    CSV =  'csv'
}

export enum FILE_EXTENSIONS{
    DOT_XLSX = '.xlsx',
    DOT_XLSM = '.xlsm',
    DOT_CSV =  '.csv'
}